export default {
    locale: 'he',
    messages: {
        common: {
            register: 'הרשם',
            login: 'התחברות',
            'full-name': 'שם מלא',
            email: 'אי-מייל',
            password: 'סיסמא',
            send: 'שליחה',
            'send-code': 'שלח קוד',
            logout: 'התנתקות',
        },
    },
};



// WEBPACK FOOTER //
// ./src/translations/he.js